import React from 'react';
import { CommentStart, CommentEnd } from '../comments';
import { useWidth, WidthProvider } from '../width-context';
import { useConfig } from '../config-context';
export function WrapperItem(props) {
    const { children } = props;
    const { width } = useWidth();
    const { renderComments } = useConfig();
    if (!renderComments) {
        return (React.createElement(WidthProvider, { value: { width: width - 32 } }, children));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(CommentStart, null),
        React.createElement("tr", null,
            React.createElement("td", { width: `${width}px` },
                React.createElement(CommentEnd, null),
                React.createElement(WidthProvider, { value: { width: width - 32 } }, children),
                React.createElement(CommentStart, null))),
        React.createElement(CommentEnd, null)));
}
//# sourceMappingURL=wrapper-item.js.map